<div
  class="notif-label-wrapper"
  [nbPopover]="notificationsTpl"
  nbPopoverPlacement="bottom-end"
  nbPopoverTrigger="click"
  nbPopoverClass="notif-popover"
>
  <nb-icon icon="bell-outline"></nb-icon>
  <nb-badge
    text="{{ count }}"
    status="danger"
    class="notif-badge"
    position="top right"
  ></nb-badge>
</div>

<ng-template #notificationsTpl>
  <div class="notifications-header">
    <span class="title">اطلاعیه‌ها</span>
    <!-- <div class="read-all" (click)="handleReadAll()">
      <span>خواندن همه</span>
      <nb-icon icon="done-all-outline"></nb-icon>
    </div> -->
  </div>
  <div class="notifications-body">
    <div class="notif-list-wrapper">
      <div *ngIf="notifications.length === 0" class="notif-empty">
        داده‌ای ثبت نشده است!
      </div>
      <div class="notif-row" *ngFor="let item of notifications">
        <div
          class="notif-content {{ item?.status }}"
          (click)="handleNotificationAction(item)"
        >
          <div class="notif-icon">
            <nb-icon icon="bell-outline"></nb-icon>
          </div>
          <div class="notif-body">
            <div class="notif-header">
              <span class="notif-title">{{ item?.title }}</span>
              <span class="notif-time">{{ item?.time }}</span>
            </div>

            <span class="notif-text">{{ item?.message }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="notifications-footer">
    <a
      routerLink="/pages/notifications"
      (click)="closePopover()"
      class="notifications-footer-link"
    >
      <span>مشاهده همه</span>
      <nb-icon icon="arrow-back-outline"></nb-icon>
    </a>
  </div>
</ng-template>
